import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadUser = useCallback(async () => {
    const token = localStorage.getItem('access_token');
    if (!token) { setLoading(false); return; }
    try {
      const res = await authAPI.getProfile();
      setUser(res.data);
    } catch {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadUser(); }, [loadUser]);

  const login = async (credentials) => {
    const res = await authAPI.login(credentials);
    localStorage.setItem('access_token', res.data.access);
    localStorage.setItem('refresh_token', res.data.refresh);
    const profile = await authAPI.getProfile();
    setUser(profile.data);
    return profile.data;
  };

  const requestOtp = async (data) => {
    return await authAPI.requestOtp(data);
  };

  // ✅ FIX: api → authAPI, aur is_new_user check
  const loginWithOtp = async ({ phone, otp }) => {
    const res = await authAPI.verifyOtp({ phone, otp }); // authAPI.verifyOtp use karo

    if (res.data.is_new_user) {
      // Naya user — profile step pe bhejna hai
      const err = new Error('New user');
      err.response = { status: 404, data: { is_new_user: true } };
      throw err;
    }

    // Existing user — tokens save karo
    const { access, refresh, user: userData } = res.data;
    localStorage.setItem('access_token', access);
    localStorage.setItem('refresh_token', refresh);
    setUser(userData);
    return userData;
  };

  const registerWithOtp = async (data) => {
    const res = await authAPI.registerWithOtp(data);
    localStorage.setItem('access_token', res.data.tokens.access);
    localStorage.setItem('refresh_token', res.data.tokens.refresh);
    setUser(res.data.user);
    return res.data.user;
  };

  const register = async (data) => {
    const res = await authAPI.register(data);
    localStorage.setItem('access_token', res.data.tokens.access);
    localStorage.setItem('refresh_token', res.data.tokens.refresh);
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = async () => {
    try {
      const refresh = localStorage.getItem('refresh_token');
      if (refresh) await authAPI.logout(refresh);
    } catch {}
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    setUser(null);
  };


const adminLogin = async (phone, password) => {
  const res = await authAPI.login({ phone, password });
  localStorage.setItem('access_token', res.data.access);
  localStorage.setItem('refresh_token', res.data.refresh);
  const profile = await authAPI.getProfile();
  setUser(profile.data);
  return profile.data;
};

  const updateUser = (data) => setUser(prev => ({ ...prev, ...data }));

  return (
    <AuthContext.Provider value={{
      user, loading,
      login, register, logout, updateUser, loadUser,
      requestOtp, loginWithOtp, registerWithOtp, adminLogin,
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};